__turbopack_context__.v({
  "previewTextWrapper": "PartialArticleLayout-module-scss-module__SW_ZzG__previewTextWrapper",
  "viewMoreWrapper": "PartialArticleLayout-module-scss-module__SW_ZzG__viewMoreWrapper",
});
